import { setChannels, setCurrentChannel, setCurrentPost } from './resolvers'

export const typeDefs = `
  type MergedChannel {
    id: String
    service: String
    serviceId: String
    organizationId: String
    name: String
    avatar: String
    isDisconnected: Boolean
    totalComments: Int
    totalPendingComments: Int
    labelsCount: [LabelCount]
    backfillingComplete: Boolean
    emojis: [String]
    updatedAt: DateTime
  }

  type CurrentPost {
    id: String
    channelId: String
    engageCompleted: Boolean
    totalPendingComments: Int
    createdAt: DateTime
    commentsUpdatedAt: DateTime
    fallbackImg: String
  }

  type Query {
    channels: [MergedChannel]
    currentChannel: MergedChannel
    currentPost: CurrentPost
  }

  type Mutation {
    setChannels (channels: [MergedChannel])
    setCurrentChannel (currentChannel: MergedChannel)
    setCurrentPost (currentPost: CurrentPost)
  }
`

export const resolvers = {
  Mutation: {
    setChannels,
    setCurrentChannel,
    setCurrentPost,
  },
}
